import { LogoMark } from "./Logo";

export const Seal = () => (
  <div className="relative grid h-28 w-28 place-items-center rounded-full bg-white shadow-[0_20px_50px_-20px_rgba(10,26,51,0.35)] sm:h-32 sm:w-32" data-testid="hero-seal">
    <svg viewBox="0 0 120 120" className="spin-slow absolute inset-0 h-full w-full">
      <defs><path id="seal-circle" d="M60,60 m-44,0 a44,44 0 1,1 88,0 a44,44 0 1,1 -88,0" /></defs>
      <text className="fill-navy font-mono text-[9.4px] uppercase tracking-[0.2em]">
        <textPath href="#seal-circle">Trust · Transparency · Quality · Partnership ·</textPath>
      </text>
    </svg>
    <LogoMark className="h-10 w-10" />
  </div>
);
